import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import Title from '../primitive/Title';
import { ModalVariant } from './Modal';

interface ModalHeaderProps extends HTMLAttributes<HTMLDivElement> {
    variant?: Exclude<ModalVariant, 'full'>;
}

const ModalHeader: FC<React.PropsWithChildren<ModalHeaderProps>> = ({ children, variant, ...props }) => (
    <ModalHeaderContainer {...props}>
        <Flex>
            <Title variant={variant} elementType="h1">
                {children}
            </Title>
        </Flex>
    </ModalHeaderContainer>
);

export default ModalHeader;

export const ModalHeaderContainer = styled.div`
    display: flex;
    justify-content: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral['30']};
    min-height: 4.8rem;
    width: 100%;
`;
